<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="'全部（'+commentList.countNum+'）'" name="0"></el-tab-pane>
      <el-tab-pane :label="'差评（'+commentList.badNum+'）'" name="1"></el-tab-pane>
      <el-tab-pane :label="'中评（'+commentList.justNum+'）'" name="2"></el-tab-pane>
      <el-tab-pane :label="'好评（'+commentList.goodNum+'）'" name="3"></el-tab-pane>
    </el-tabs>
    <br>
    <el-date-picker v-model="month" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :editable="false" :clearable="false" @change="onTimeChange" />
    <br>
    <br>
    <div v-if="commentList.lookTechnicianScores.length != 0" class="comment_content">
      <ul class="comment_content_list">
        <li v-for="(item,index) in commentList.lookTechnicianScores" :key="index" class="comment_content_list_item">
          <p class="list_info">
            <el-tooltip class="item" effect="light" :content="item.orderCode" placement="top-start">
              <span class="technicianName orderCCode">订单号：{{ item.orderCode }}</span>
            </el-tooltip>
            <span>评价时间：{{ item.assessTime }}</span>
          </p>

          <div class="list_content">
            <!-- <img :src="'static/images/head.png'" style="border-radius:80px;"> -->
            <img :src="item.headUrl === null?'static/images/head.png':item.headUrl" style="border-radius:80px;">
            <div class="list_content_info">
              <p>{{ item.customerName }}</p>
              <p>
                <el-tooltip class="item" effect="light" :content="item.technicianName" placement="top-start">
                  <span class="technicianName" style="max-width:45px;">{{ item.technicianName }}</span>
                </el-tooltip>
                <!-- <span>{{item.technicianName}}</span> -->
                <el-tooltip class="item" effect="light" :content="item.itemName" placement="top-start">
                  <span class="technicianName" style="max-width:100px;">{{ item.itemName }}</span>
                </el-tooltip>
                <!--  {{item.itemName} -->
                <span>打分</span>
                <i v-for="(items,indexs) in item.grade" :key="indexs" class="iconfont" style="color: #ffc974;font-size:16px">&#xe667;</i>
              </p>
              <p>
                <i class="iconfont" style="color:#b5b5b5">&#xe613;</i>
                <ul class="comment_tag_list">
                  <li class="comment_tag_list_item">{{ !item.tag? '暂无':item.tag }}</li>
                  <!-- <li class="comment_tag_list_item" v-for="(itemss,indess) in item.tag.split(',')" :key="indess">{{itemss}}</li> -->
                </ul>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <p v-else class="no_data">
      <i class="el-icon-warning" style="font-size:30px;color:#cecece"></i>
      <br>
      <br>
      <span>暂无数据</span>
    </p>
    <!-- <br>
        <br> -->
    <el-pagination v-if="commentList.lookTechnicianScores.length != 0" background :page-size="6" layout="prev, pager, next, jumper" :total="total" :current-page.sync="pageNo" @current-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getCommentList } from './api';

export default {
  data() {
    return {
      activeName: '0',
      month: ['', ''],
      commentList: {
        lookTechnicianScores: []
      },
      pageNo: 1,
      pageSize: 6,
      total: 0
    };
  },
  activated() {
    this.onGetCommentList();
  },
  methods: {
    handleClick() {
      this.pageNo = 1;
      this.onGetCommentList();
    },
    onTimeChange() {
      this.onGetCommentList();
    },
    // 获取评价列表
    onGetCommentList() {
      const data = {
        beginTime: this.month[0] === '' ? '' : dayjs(this.month[0]).format('YYYY-MM-DD'),
        endTime: this.month[1] === '' ? '' : dayjs(this.month[1]).format('YYYY-MM-DD'),
        grade: Number(this.activeName),
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      getCommentList(sessionStorage.getItem('mainId'), data).then((res) => {
        this.commentList = res.data;
        if (Number(this.activeName) === 0) {
          this.total = res.data.countNum;
        } else if (Number(this.activeName) === 1) {
          this.total = res.data.badNum;
        } else if (Number(this.activeName) === 2) {
          this.total = res.data.justNum;
        } else if (Number(this.activeName) === 3) {
          this.total = res.data.goodNum;
        }
      });
    },
    // 分页按钮
    handleSizeChange(val) {
      this.pageNo = val;
      this.onGetCommentList();
    }
  }
};
</script>

<style lang="less" scoped>
.comment_header {
    display: flex;
    align-items: center;
    box-shadow: 0px 6px 20px 0px rgba(53, 53, 53, 0.05);
    border-radius: 6px;
    width: 343px;
    height: 60px;
    cursor: pointer;
    // &:hover {
    //     box-shadow: 0px 2px 10px 0px #dcdcdc;
    // }
    img {
        margin-left: 20px;
        width: 40px;
        height: 40px;
    }
    span {
        margin-left: 15px;
        font-size: 14px;
    }
}
.comment_content {
    .comment_content_list {
        list-style: none;
        display: flex;
        // justify-content: space-between;
        flex-flow: wrap;
        border-radius: 4px;
        // justify-content: space-between;
        .comment_content_list_item {
            margin-bottom: 20px;
            margin-right: 20px;
            flex: 0 1 32%;
            border: solid 1px #d8dce5;
            // margin-right: 19px;
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                flex: 0 1 48%;
                margin-right: 10px;
            }
            @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
                flex: 0 1 48%;
                margin-right: 10px;
            }
            .list_info {
                color: #818691;
                padding: 11px 21px;
                background-color: #f5f7fa;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
            }
            .list_content {
                padding: 20px 34px;
                display: flex;
                img {
                    width: 45px;
                    height: 45px;
                    flex-shrink: 0;
                }
                .list_content_info {
                    margin-left: 10px;
                    margin-top: 12px;
                    color: #333333;
                    p:nth-child(2) {
                        font-size: 15px;
                        margin-top: 24px;
                        display: flex;
                        align-items: center;

                        span {
                            margin-right: 20px;
                            &:nth-child(3) {
                                margin-right: 5px;
                            }
                        }
                    }
                    p:nth-child(3) {
                        margin-top: 19px;
                        display: flex;
                        .comment_tag_list {
                            list-style: none;
                            display: flex;
                            flex-flow: wrap;
                            margin-left: 10px;
                            .comment_tag_list_item {
                                white-space: nowrap;
                                font-size: 14px;
                                color: #999999;
                                flex: 0 4 23%;
                                @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                                    flex: 0 1 31%;
                                }
                                @media only screen and (min-device-width: 1366px) and (max-device-width: 1900px) and (orientation: landscape) {
                                    flex: 0 1 47%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
.no_data {
    text-align: center;
    padding: 30px;
    margin: 10px;
    margin-top: 0px;
    border: solid 1px #d8dce5;
    span {
        font-size: 14px;
        color: #999999;
        margin-top: 17px;
    }
}
.technicianName {
    // width: 90px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
    white-space: nowrap;
}
.orderCCode {
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
        max-width: 140px;
    }
    @media only screen and (min-device-width: 1366px) and (max-device-width: 1900px) and (orientation: landscape) {
        max-width: 140px;
    }
}
</style>
